import { Expo, Linear } from "gsap";
import * as HLF from "html-living-framework";
import {HoverableButton, TextureButton} from "../core/Button";
import { IPoint } from "../core/Geom";
import {Callback, Mix} from "../core/Reflection";
import {TransformBackup} from "../core/TransformBackup";
import {TrashType} from "../data/TrashType";
import { TrashItem } from "./TrashItem";

export class TrashItemCollect extends TrashItem {
    public pickedUp: boolean;
    public rotatable: boolean;

    constructor(trashType: TrashType, texture: string, rotatable: boolean, voiceoverA: string, voiceoverB: string, voiceoverC: string) {
        super(trashType, texture, voiceoverA, voiceoverB, voiceoverC);
        this.pickedUp = false;
        this.enabled = false;
        this.visible = false;
        this.rotatable = rotatable;
    }

    public QueuedForPickup() {
        this.enabled = false;
        // this.sprite.tint = HLF.Colour.GREEN.toHex();
    }

    public QueuedPickupCancelled() {
        this.enabled = true;
        // this.sprite.tint = HLF.Colour.WHITE.toHex();
    }

    public PickUp(nozzlePos: IPoint, cb?: Callback) {
        if (!this.pickedUp) {
            this.alphaTo(0, 0.75, cb);
            this.moveXTo(nozzlePos.x, 0.75, Expo.easeOut);
            this.moveYTo(nozzlePos.y, 0.5, Expo.easeIn);
            this.pickedUp = true;
            HLF.Application.instance.audio.play("correctanswer", 1, false, HLF.AudioCategory.SFX);
        }
    }
}
